import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

// Single shared MSAL instance. Created here (rather than inline in App.jsx) so
// non-React modules — e.g. src/utils/apiToken.js, used by the SQL/Claude clients
// to attach an Entra bearer token — can acquire tokens from the same instance.
export const msalInstance = new PublicClientApplication(msalConfig);
